import * as ActionTypes from './actionTypes';
import apiState from './propertiesApiState';

export default function globalReducer(state = {}, action) {
  switch (action.type) {
    default:
      return {
        ...state
      };
  }
}
